module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/client-open-nclosed-ticket-count/client-open-nclosed-ticket-count.component.css
// module id = ./src/app/reports/client-open-nclosed-ticket-count/client-open-nclosed-ticket-count.component.css
// module chunks = main